"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const check_tooltip_svg_1 = __importDefault(require("images/utility-icons/check-tooltip.svg"));
const tooltip_icon_svg_1 = __importDefault(require("images/utility-icons/tooltip-icon.svg"));
function CheckTooltip({ index, type }) {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const handleMouseOver = () => {
        setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "label-and-tooltip-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "check-tooltip", children: [(0, jsx_runtime_1.jsx)("img", { src: tooltip_icon_svg_1.default, alt: "information", className: "tooltip-icon", onMouseOver: handleMouseOver, onFocus: handleMouseOver, onMouseLeave: handleMouseLeave, "data-testid": `check-tooltip-${type}-${index}` }), (0, jsx_runtime_1.jsx)("div", { className: `tooltip-container ${showTooltip ? 'visible' : ''}`, children: (0, jsx_runtime_1.jsx)("img", { src: check_tooltip_svg_1.default, alt: "Tooltip" }) })] }) }));
}
exports.default = CheckTooltip;
